import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Colors } from '../../../shared/enums/shared.enums';
import { MultimediaItem } from '../../../shared/interfaces/multimedia-item.interface';

@Component({
  selector: 'hdi-multimedia-section',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './multimedia-section.component.html',
  styleUrl: './multimedia-section.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class MultimediaSectionComponent {
  @Input() MultimediaItems!: MultimediaItem[];
  @Input() headline?: string;
  IconBlack = Colors.BLACK;
  IconPDF = 'pdf';
  iconDownload = 'download';
  IconExternal = 'external-link';
}
